<div class="root-container">
  <form class="form-group" [formGroup]="form()">
    <div class="row">
      <!-- Region dropdown -->
      <div class="col-lg-4 col-md-6 d-flex flex-column">
        <label  class=" mb-2 label-required">Region</label>
        <select formControlName="region_id">
          <option disabled value="">Select Region</option>
          @for (i of data_regions();track i.uuid){
            <option [value]="i.uuid">{{ i.name }}</option>
          }
        </select>
      </div>

      <!-- Province dropdown -->
      <div class="col-lg-4 col-md-6 d-flex flex-column">
          <div class="d-flex">
              <label  class=" mb-2 label-required">Province</label>
          </div>
        <select formControlName="province_id">
          <option disabled value="">Select Province</option>
          @for (i of data_provinces;track i.uuid){
            <option [value]="i.uuid">{{ i.name }}</option>
          }
        </select>
      </div>

      <!-- City dropdown -->
      <div class="col-lg-4 col-md-6 d-flex flex-column">
          <div class="d-flex">
              <label  class=" mb-2 label-required">City / Municipality
              </label>
          </div>
          <select formControlName="city_id">
            <option disabled value="">Select City</option>
            @for (i of data_city;track i.uuid){
              <option [value]="i.uuid">{{ i.name }}</option>
            }
          </select>
      </div>
    </div>

    <!-- Address Field -->
    <div class="row mt-4 mx-1 col col-lg-8">
        <label for="address" class=" mb-2 p-0 label-required">House/Bldg No., Street, Subdivision</label>
        <input
                type="text"
                id="address"
                name="address"
                class="form-control"
                formControlName="address"
                required
        />
        <div class="error-label">
            <validation-error
                    [form]="form()"
                    controlName="address"
                    [validation]="{
                      required: 'Address is required',
                      emojiNotAllowed: 'Emoji is not allowed',
                      maxlength: 'Address must be 100 characters only'
                    }"
            />
        </div>
    </div>
  </form>
</div>
